import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useTask } from "context/admin/task";
import { useTaskView } from "context/admin/task_view";

import ModalNew from "components/ModalNew";
import Button from "components/Button";

const mainClass = "task-view-main-tracker-delete";

const ModalDelete = ({ data, time_entries, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { deleteTaskTime } = useTask();
  const { refetch } = useTaskView();

  const { type, id, name, time } = data || {};

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      if (type === "total_time") {
        for (let i = 0; i < time_entries.length; i++) {
          const isLast = i === time_entries.length - 1;
          await deleteTaskTime(time_entries[i]._id, !isLast);
        }
      } else {
        await deleteTaskTime(id);
      }
      await refetch(true);

      setTimeout(() => {
        setLoading(false);
        if (typeof onClose === "function") onClose();
      }, 300);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <ModalNew
      title={`${t("Delete work time")}: ${time}`}
      variant="delete"
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <p>
          {t(
            type === "total_time"
              ? "Are you sure you want to delete the total time of"
              : "Are you sure you want to delete the time of",
          )}{" "}
          <strong>{name}</strong>? <u>{t("This action cannot be undone")}</u>.
        </p>
        <div className={`${mainClass}__cta`}>
          <Button disabled={loading} onClick={handleSubmit}>
            {t(loading ? "Deleting..." : "Delete")}
          </Button>
        </div>
      </div>
    </ModalNew>
  );
};

export default ModalDelete;
